import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { PrismicText, SliceZone } from '@prismicio/react'

import { IMarkupSchemas } from 'components/SEOMarkupSchema'
import { components } from 'slices'

import { PageDocument } from 'types/prismic'
import { getEnv } from 'utils/env/env.util'
import { getFullPageByUID } from 'utils/prismic'
const { baseUrl } = getEnv()

const SubscriptionRules = ({ page }: { page: PageDocument<string> }) => {
  return (
    <div className="mt-[50px] px-5 xl:px-0">
      <div className="mb-3">
        <h1 className="mb-2 text-3xl font-bold sm:text-5xl ">
          <PrismicText field={page.data.title}></PrismicText>
          <i className="dot"></i>
        </h1>
      </div>
      <SliceZone slices={page.data.slices} components={components} />
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({
  locale: currentLocale,
  defaultLocale,
  previewData
}) => {
  const locale = currentLocale || defaultLocale || 'en'

  const pagePartsPromise = getFullPageByUID(
    'page',
    'subscription-rules',
    { locale },
    { previewData }
  )

  const i18nPromise = serverSideTranslations(locale, ['actions', 'crm'])

  const [pageParts, i18n] = await Promise.all([pagePartsPromise, i18nPromise])
  const { page, ...layoutParts } = pageParts
  const [seo] = page?.data?.seo ?? []
  const markupSchema: IMarkupSchemas = [
    {
      type: 'BreadcrumbList',
      data: {
        items: [{ name: 'Home', item: baseUrl }, { name: 'Privacy Policy' }]
      }
    }
  ]
  return {
    props: {
      ...i18n,
      page,
      seo: seo?.primary ?? null,
      internal: {
        layout: layoutParts
      },
      markupSchema
    },
    revalidate: 60 * 60 * 24 // 24 hours
  }
}

export default SubscriptionRules
